import * as pc from 'playcanvas';

// Player 1 keyboard controls (WASD + Space/F/Shift)
export const PLAYER1_KEYBOARD = {
    up: [pc.KEY_W],
    down: [pc.KEY_S],
    left: [pc.KEY_A],
    right: [pc.KEY_D],
    jump: [pc.KEY_SPACE],
    attack: [pc.KEY_F],
    dodge: [pc.KEY_SHIFT]
};

// Player 2 keyboard controls (Arrow keys + Enter/RShift)
export const PLAYER2_KEYBOARD = {
    up: [pc.KEY_UP],
    down: [pc.KEY_DOWN],
    left: [pc.KEY_LEFT],
    right: [pc.KEY_RIGHT],
    jump: [pc.KEY_ENTER],
    attack: [pc.KEY_END],  // End key for P2 attack
    dodge: [190]  // Right shift (key code 190 or similar)
};

// Gamepad button mappings (Nintendo Switch Pro Controller / standard gamepad)
export const GAMEPAD_BUTTONS = {
    // Face buttons
    B: 0,
    A: 1,  // Jump
    Y: 2,  // Attack
    X: 3,
    // Shoulder buttons
    L: 4,  // Dodge
    R: 5,  // Dodge
    ZL: 6,
    ZR: 7,
    // Other
    MINUS: 8,
    PLUS: 9,  // Menu
    L_STICK: 10,
    R_STICK: 11,
    // D-pad
    DPAD_UP: 12,
    DPAD_DOWN: 13,
    DPAD_LEFT: 14,
    DPAD_RIGHT: 15
};

// Gamepad axes
export const GAMEPAD_AXES = {
    LEFT_STICK_X: 0,
    LEFT_STICK_Y: 1,
    RIGHT_STICK_X: 2,
    RIGHT_STICK_Y: 3
};

// Deadzone for analog sticks
export const STICK_DEADZONE = 0.15;

// Movement speed
export const MOVE_SPEED = 5;
export const JUMP_FORCE = 12;

// Get connected gamepads
export function getGamepads() {
    return navigator.getGamepads ? navigator.getGamepads() : [];
}

// Get gamepad for specific player (0-indexed)
export function getGamepadForPlayer(playerIndex) {
    const pads = getGamepads();
    return pads[playerIndex] || null;
}

// Check if a button is pressed
export function isButtonPressed(gamepad, buttonIndex) {
    if (!gamepad || !gamepad.buttons[buttonIndex]) return false;
    return gamepad.buttons[buttonIndex].pressed;
}

// Get axis value with deadzone
export function getAxisValue(gamepad, axisIndex) {
    if (!gamepad || gamepad.axes[axisIndex] === undefined) return 0;
    const value = gamepad.axes[axisIndex];
    return Math.abs(value) > STICK_DEADZONE ? value : 0;
}

// Get first connected gamepad (for single player or menu)
export function getFirstGamepad() {
    const pads = getGamepads();
    return pads[0] || pads[1] || pads[2] || pads[3] || null;
}
